import React from 'react'
import { bool, func } from 'prop-types'
import media from '../../../utils/style'
import styled from 'styled-components'
import IconFormArrowRight from '../../../vectors/IconFormArrowRight'

const PaginationWrapper = styled.div`
  display: none;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 20px;
  margin-bottom: 20px;
  z-index: 30;

  ${media.MediumScreenUp`
    display: flex;
  `};
`

const IconFormArrowLeft = styled(IconFormArrowRight)`
  transform: rotate(180deg);
`

const ButtonNext = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.colors.white};
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease-out;

  svg {
    width: 44px;
    height: 32px;
  }
  g,
  path {
    fill: currentColor;
    stroke: rgba(0, 0, 0, 0.2);
    stroke-width: 2px;
  }

  &[disabled] {
    color: ${(props) => props.theme.colors.blue_light_op50};
    pointer-events: none;
  }

  &:hover,
  &:focus,
  &:active {
    color: lightblue;
  }
`

const ButtonPrev = styled(ButtonNext)`
  margin-right: 32px;
`

export default function Pagination(props) {
  const { onNext, onPrevious, previousDisabled, nextDisabled } = props
  return (
    <PaginationWrapper>
      <ButtonPrev
        onClick={onPrevious}
        disabled={previousDisabled}
        aria-label="Previous Item"
      >
        <IconFormArrowLeft />
      </ButtonPrev>
      <ButtonNext
        onClick={onNext}
        disabled={nextDisabled}
        aria-label="Next Item"
      >
        <IconFormArrowRight />
      </ButtonNext>
    </PaginationWrapper>
  )
}

Pagination.propTypes = {
  nextDisabled: bool,
  previous: bool,
  onNext: func.isRequired,
  onPrevious: func.isRequired
}
